"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const mobx_react_lite_1 = require("mobx-react-lite");
const styles_1 = require("./styles");
const styling_1 = require("../../../styling");
const Eye_1 = tslib_1.__importDefault(require("../../Icons/Eye"));
const CarouselViewCount = (0, mobx_react_lite_1.observer)(({ classes, viewCount }) => {
    const mergedClasses = (0, styling_1.useStyles)({ target: classes !== null && classes !== void 0 ? classes : {}, source: styles_1.viewCountStyles }, "view-count");
    return (react_1.default.createElement("div", { className: mergedClasses.root },
        react_1.default.createElement(Eye_1.default, { className: mergedClasses.eyeIcon }),
        react_1.default.createElement("span", null, viewCount)));
});
exports.default = CarouselViewCount;
//# sourceMappingURL=index.js.map